export default "__VITE_ASSET__c5e4fa37__"